import React, { useContext, useEffect, useState } from "react";
import Form from "../../components/form";
import { CircularProgress } from "@mui/material";
import api from "../../services/api";
import AppContext from "../../container/context";
import ActionTable from "../../components/table/ActionTable";

export default function Escola(props) {
  const [escolaId] = useState(Number(props.match.params.id));
  const history = props.history;
  const [escola, setEscola] = useState({});
  const [comboConsultores, setComboConsultores] = useState([]);
  const [comboCarteiras, setComboCarteiras] = useState([]);
  const [comboCiclos, setComboCiclos] = useState([]);
  const [ciclos, setCiclos] = useState([]);
  const [carregando, setCarregando] = useState(false);
  const [alterarCiclo, setAlterarCiclo] = useState(false);
  const [cicloId, setCicloId] = useState(0);
  const [cicloNome, setCicloNome] = useState({});
  const { notification } = useContext(AppContext);

  useEffect(() => {
    carregarComboConsultores();
    carregarComboCarteiras();
    carregarComboCiclos();
    if (escolaId > 0) {
      carregarEscola();
      carregarCiclos();
    }
  }, []);

  const carregarEscola = () => {
    setCarregando(true);
    api.get("escolas/carregar", { id: escolaId }).then((escola) => {
      setEscola(escola);
      setCarregando(false);
    });
  };

  const carregarCiclos = () => {
    api
      .get("escolas/listarCiclos", { escolaId: escolaId })
      .then((ciclos) => setCiclos(ciclos));
  };

  const carregarComboCiclos = () => {
    api.get("ciclos/listar").then((combo) => {
      setComboCiclos(combo);
    });
  };

  const carregarComboConsultores = () => {
    api
      .get("consultores/listar")
      .then((comboConsultores) => {
        setComboConsultores(comboConsultores);
      })
      .catch((err) => notification("error", "Erro ao listar os consultores"));
  };

  const carregarComboCarteiras = () => {
    api
      .get("carteiras/listar")
      .then((carteiras) => {
        setComboCarteiras(carteiras);
      })
      .catch((err) => notification("error", "Erro ao listar os carteiras"));
  };

  const salvar = (params) => {
    setEscola(params);

    if (escolaId === 0) {
      api
        .put("escolas/inserir", params)
        .then((res) => {
          notification("success", "Escolas inserida!");
          history.push("/app/escola");
        })
        .catch((err) => {
          const { data } = err;
          switch (data[0]) {
            case 1:
              return notification("error", "Razão social inválida");
            case 2:
              return notification("error", "Nome fantasia inválido");
            case 3:
              return notification("error", "CEP inválido");
            case 4:
              return notification("error", "Endereço inválido");
            case 5:
              return notification("error", "Número inválido");
            case 6:
              return notification("error", "Bairro inválido");
            case 7:
              return notification("error", "Município inválido");
            case 8:
              return notification("error", "UF inválida");
            default:
              return notification("error", "Dados inválidos");
          }
        });
    } else {
      params.id = escolaId;

      api
        .post("escolas/salvarDadosCadastrais", params)
        .then((res) => {
          notification("success", "Escolas editada!");
          history.push("/app/escola");
        })
        .catch((err) => {
          const { data } = err;
          switch (data[0]) {
            case 1:
              return notification("error", "Razão social inválida");
            case 2:
              return notification("error", "Nome fantasia inválido");
            case 3:
              return notification("error", "CEP inválido");
            case 4:
              return notification("error", "Endereço inválido");
            case 5:
              return notification("error", "Número inválido");
            case 6:
              return notification("error", "Bairro inválido");
            case 7:
              return notification("error", "Município inválido");
            case 8:
              return notification("error", "UF inválida");
            default:
              return notification("error", "Dados inválidos");
          }
        });
    }
  };

  const camposDados = () => {
    const campos = {
      razaoSocial: {
        label: "Razão social",
        type: "text",
        space: 6,
        value: escola.razaoSocial,
      },
    };

    campos.nomeFantasia = {
      label: "Nome fantasia",
      type: "text",
      value: escola.nomeFantasia,
      space: 6,
    };
    // campos.coordenadorId = {
    //   label: "Coodernador(a)/Diretor(a)",
    //   type: "select",
    //   value: escola.coordenadorId,
    //   space: 6,
    //   emptyItem: true,
    //   emptyItemText: "(Nenhum)",
    // };
    campos.CNPJ = {
      label: "CNPJ",
      type: "text",
      value: escola.CNPJ,
      space: 6,
    };
    campos.consultorId = {
      label: "Regional/Manager responsável",
      type: "select",
      value: escola.consultorId,
      space: 6,
      array: {
        data: comboConsultores,
        value: "id",
        desc: "usuarioNome",
      },
      emptyItem: true,
      emptyItemText: "(Nenhum)",
    };
    campos.patente = {
      label: "Patente",
      type: "select",
      emptyItem: true,
      emptyItemText: "(Nenhuma)",
      options: [
        {
          value: 1,
          desc: "Low",
        },
        {
          value: 2,
          desc: "Med",
        },
        {
          value: 3,
          desc: "High",
        },
      ],
      value: escola.patente,
      space: 6,
    };
    campos.carteiraId = {
      label: "Carteira",
      type: "select",
      array: {
        data: comboCarteiras,
        value: "id",
        desc: "nome",
      },
      emptyItem: true,
      emptyItemText: "(Nenhuma)",
      value: escola.carteiraId,
      space: 6,
    };
    campos.rankingAtivo = {
      label: "Ranking liberado",
      type: "check",
      value: escola.rankingAtivo,
      space: 6,
    };
    campos.ativa = {
      label: "Escola ativa",
      type: "check",
      value: escolaId > 0 ? escola.ativa : true,
      space: 6,
    };

    campos.CEP = {
      label: "CEP",
      type: "text",
      value: escola.CEP,
      space: 2,
    };
    campos.endereco = {
      label: "Logradouro",
      type: "text",
      value: escola.endereco,
      space: 6,
    };
    campos.numero = {
      label: "Número",
      type: "text",
      value: escola.numero,
      space: 1,
    };
    campos.complemento = {
      label: "Complemento",
      type: "text",
      value: escola.complemento,
      space: 3,
    };
    campos.bairro = {
      label: "Bairro",
      type: "text",
      value: escola.bairro,
      space: 5,
    };
    campos.municipio = {
      label: "Município",
      type: "text",
      value: escola.municipio,
      space: 5,
    };
    campos.UF = {
      label: "UF",
      type: "text",
      value: escola.UF,
      space: 2,
    };

    // campos.emailFinanceiro = {
    //   label: "Email financeiro",
    //   type: "text",
    //   value: escola.emailFinanceiro,
    //   space: 6,
    // };

    campos.observacoes = {
      label: "Observações",
      type: "textarea",
      value: escola.observacoes,
    };

    if (escolaId > 0) {
      campos.link = {
        type: "component",
        value: (
          <div>
            <a
              href={`${window.location.origin}/app/escola-config-pedido?id=${escolaId}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              Consultar e gerenciar dados para pedidos
            </a>
          </div>
        ),
      };
    }

    return campos;
  };

  const fDados = {
    title: "Dados cadastrais",
    form: camposDados(),
    submit: {
      label: "Salvar",
      action: salvar,
    },

    history,
    close: true,
  };

  const selecionarCiclo = (registro) => {
    setCicloNome(registro);
    setCicloId(registro.cicloId);
    setAlterarCiclo(true);
  };

  const tRegistros = {
    title: "Ciclos adiquiridos",
    onLineClick: selecionarCiclo,
    newItemAction: () => setAlterarCiclo(true),
    columns: [
      {
        name: "cicloNome",
        label: "Nome",
      },
    ],
    array: ciclos,
  };

  const inserirCiclo = (id) => {
    api
      .post("escolas/inserirCiclo", { escolaId: escolaId, cicloId: id.cicloId })
      .then((res) => {
        notification("success", "Ciclo adicionado");
        setAlterarCiclo(false);
        setCicloId(0);
        carregarCiclos();
      })
      .catch((err) => {
        const { data } = err;
        switch (data[0]) {
          case 1:
            return notification("error", "Escola inválida");
          case 2:
            return notification("error", "Ciclo inválido");
          case 3:
            return notification("error", "Ciclo já vinculado");
          default:
            return notification("error", "Dados inválidos");
        }
      });
  };
  const removerCiclo = () => {
    api
      .post("escolas/removerCiclo", { escolaId: escolaId, cicloId: cicloId })
      .then((res) => {
        notification("success", "Ciclo Removido");
        setAlterarCiclo(false);
        setCicloId(0);
        carregarCiclos();
      })
      .catch((err) => notification("error", "Erro ao remover ciclo"));
  };

  const fCiclos = {
    title: "Ciclo",
    form: {
      cicloId: {
        label: "Ciclo",
        type: "select",
        emptyItem: true,
        array: {
          data: comboCiclos,
          value: "id",
          desc: "nome",
        },
        value: cicloId,
      },
    },

    submit: {
      label: "salvar",
      action: inserirCiclo,
    },
    close: {
      label: "Fechar",
      action: () => {
        setAlterarCiclo(false);
        setCicloId(0);
      },
    },
    customActions:
      cicloId > 0
        ? [
            {
              label: "Remover",
              action: () => removerCiclo(),
            },
          ]
        : undefined,
  };

  if (cicloId > 0) {
    fCiclos.form.cicloId = {
      type: "component",
      value: (
        <>
          <p>{cicloNome.cicloNome}</p>
        </>
      ),
    };
  }

  return (
    <div>
      {carregando ? <CircularProgress /> : <Form formData={fDados} />}
      {escolaId > 0 && (
        <>
          {!alterarCiclo ? (
            <>
              <ActionTable structure={tRegistros} />
            </>
          ) : (
            <Form formData={fCiclos} />
          )}
        </>
      )}
    </div>
  );
}
